export class Key
{
    private key : number;

    constructor()
    {
        this.key = 0;
    }

    get() : number
    {
        return this.key++;
    }
}
